/**
 * "Talk it through" drafted a solution customers should reach by phone, but
 * creating it only makes Pype channels. This remembers the ask, per
 * solution, so Design can offer the Voice channel until there is one or it's
 * dismissed. A per-browser nudge, nothing more — so browser storage, and it
 * quietly does nothing where storage is unavailable.
 */
const key = (uniqueId: string) => `pro-studio:wants-voice:${uniqueId}`;

export const markWantsVoice = (uniqueId: string) => {
  try {
    window.localStorage.setItem(key(uniqueId), '1');
  } catch {
    // Blocked storage: no nudge, nothing lost.
  }
};

export const wantsVoice = (uniqueId: string | undefined): boolean => {
  if (!uniqueId) return false;
  try {
    return window.localStorage.getItem(key(uniqueId)) === '1';
  } catch {
    return false;
  }
};

export const clearWantsVoice = (uniqueId: string) => {
  try {
    window.localStorage.removeItem(key(uniqueId));
  } catch {
    // Nothing to clear.
  }
};
